module.exports = __webpack_public_path__ + "static/img/rolesuc.c17b26b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rolesuc.png
// module id = cq34
// module chunks = 1